import { __DEV__ } from "../config/env";

export const print = (...args: any) => {
  __DEV__ && console.log(...args);
};

export const log = print;
export const debug = print;
